module.exports = __webpack_public_path__ + "static/img/SS.782de8eb.svg";